
export const countyAssessors = {
  'CA': [
    {
      county: 'Los Angeles County',
      assessorName: 'Los Angeles County Assessor',
      website: 'https://assessor.lacounty.gov',
      phone: '(213) 974-3211',
      address: '500 W Temple St, Los Angeles, CA 90012',
      services: ['Property Search', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Orange County',
      assessorName: 'Orange County Assessor',
      website: 'https://www.ocassessor.com',
      phone: '(714) 834-2727',
      address: '12 Civic Center Plaza, Santa Ana, CA 92701',
      services: ['Property Valuation', 'Tax Information', 'Property Records', 'Appeals Process']
    },
    {
      county: 'San Diego County',
      assessorName: 'San Diego County Assessor',
      website: 'https://www.sdcounty.ca.gov/assessor',
      phone: '(619) 236-3771',
      address: '1600 Pacific Hwy, San Diego, CA 92101',
      services: ['Assessment Appeals', 'Property Search', 'Tax Exemptions', 'Records']
    },
    {
      county: 'Riverside County',
      assessorName: 'Riverside County Assessor-County Clerk-Recorder',
      website: 'https://www.rivcoacr.org',
      phone: '(951) 955-6200',
      address: '2724 Gateway Dr, Riverside, CA 92507',
      services: ['Property Assessment', 'Public Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'San Bernardino County',
      assessorName: 'San Bernardino County Assessor-Recorder-County Clerk',
      website: 'https://www.sbcounty.gov/arc',
      phone: '(909) 387-8307',
      address: '222 W Hospitality Ln, San Bernardino, CA 92415',
      services: ['Property Records', 'Assessment Information', 'Tax Data', 'Appeals']
    },
    {
      county: 'Santa Clara County',
      assessorName: 'Santa Clara County Assessor',
      website: 'https://www.sccassessor.org',
      phone: '(408) 299-5500',
      address: '70 W Hedding St, San Jose, CA 95110',
      services: ['Property Assessment', 'Tax Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Alameda County',
      assessorName: 'Alameda County Assessor',
      website: 'https://www.acassessor.org',
      phone: '(510) 272-3787',
      address: '1221 Oak St, Oakland, CA 94612',
      services: ['Property Search', 'Assessment Appeals', 'Tax Information', 'Records']
    },
    {
      county: 'Sacramento County',
      assessorName: 'Sacramento County Assessor',
      website: 'https://assessor.saccounty.net',
      phone: '(916) 875-0700',
      address: '3701 Power Inn Rd, Sacramento, CA 95826',
      services: ['Property Valuation', 'Tax Records', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Contra Costa County',
      assessorName: 'Contra Costa County Assessor',
      website: 'https://www.cocotax.us',
      phone: '(925) 313-7400',
      address: '651 Pine St, Martinez, CA 94553',
      services: ['Property Assessment', 'Tax Information', 'Appeals', 'Records Search']
    },
    {
      county: 'Fresno County',
      assessorName: 'Fresno County Assessor-Recorder',
      website: 'https://www.co.fresno.ca.us/departments/assessor-recorder',
      phone: '(559) 600-3471',
      address: '2281 Tulare St, Fresno, CA 93721',
      services: ['Property Records', 'Assessment Data', 'Tax Information', 'Appeals']
    }
  ],
  'TX': [
    {
      county: 'Harris County',
      assessorName: 'Harris County Appraisal District',
      website: 'https://www.hcad.org',
      phone: '(713) 957-7800',
      address: '13013 Northwest Fwy, Houston, TX 77040',
      services: ['Property Search', 'Appraisal Records', 'Protests', 'Exemptions']
    },
    {
      county: 'Dallas County',
      assessorName: 'Dallas Central Appraisal District',
      website: 'https://www.dallascad.org',
      phone: '(214) 631-0910',
      address: '2949 N Stemmons Fwy, Dallas, TX 75247',
      services: ['Property Valuation', 'Tax Records', 'Appeals', 'Homestead Exemptions']
    },
    {
      county: 'Tarrant County',
      assessorName: 'Tarrant Appraisal District',
      website: 'https://www.tad.org',
      phone: '(817) 284-7300',
      address: '2500 Handley Ederville Rd, Fort Worth, TX 76118',
      services: ['Property Assessment', 'Tax Information', 'Protest Process', 'Records']
    },
    {
      county: 'Bexar County',
      assessorName: 'Bexar Appraisal District',
      website: 'https://www.bcad.org',
      phone: '(210) 242-2000',
      address: '411 N Frio St, San Antonio, TX 78207',
      services: ['Property Search', 'Appraisal Information', 'Appeals', 'Exemptions']
    },
    {
      county: 'Travis County',
      assessorName: 'Travis Central Appraisal District',
      website: 'https://www.traviscad.org',
      phone: '(512) 834-9317',
      address: '8314 Cross Park Dr, Austin, TX 78754',
      services: ['Property Records', 'Tax Assessment', 'Protest Procedures', 'Exemptions']
    },
    {
      county: 'Collin County',
      assessorName: 'Collin Central Appraisal District',
      website: 'https://www.collincad.org',
      phone: '(972) 881-9924',
      address: '250 Eldorado Pkwy, McKinney, TX 75069',
      services: ['Property Valuation', 'Tax Records', 'Appeals', 'Homestead Exemptions']
    },
    {
      county: 'Denton County',
      assessorName: 'Denton Central Appraisal District',
      website: 'https://www.dentoncad.com',
      phone: '(940) 349-3800',
      address: '1717 Industrial Rd, Denton, TX 76207',
      services: ['Property Assessment', 'Tax Information', 'Protest Process', 'Records']
    },
    {
      county: 'Fort Bend County',
      assessorName: 'Fort Bend Central Appraisal District',
      website: 'https://www.fbcad.org',
      phone: '(281) 344-8623',
      address: '2801 B F Terry Blvd, Rosenberg, TX 77471',
      services: ['Property Search', 'Appraisal Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'El Paso County',
      assessorName: 'El Paso Central Appraisal District',
      website: 'https://www.epcad.org',
      phone: '(915) 780-2000',
      address: '5801 Trowbridge Dr, El Paso, TX 79925',
      services: ['Property Valuation', 'Tax Records', 'Protest Procedures', 'Records']
    },
    {
      county: 'Williamson County',
      assessorName: 'Williamson Central Appraisal District',
      website: 'https://www.wcad.org',
      phone: '(512) 930-3787',
      address: '625 FM 1460, Georgetown, TX 78626',
      services: ['Property Assessment', 'Tax Information', 'Appeals', 'Exemptions']
    },
    {
      county: 'Hidalgo County',
      assessorName: 'Hidalgo County Appraisal District',
      website: 'https://www.hidalgocad.org',
      phone: '(956) 383-2814',
      address: '100 N 10th St, McAllen, TX 78501',
      services: ['Property Search', 'Appraisal Information', 'Protests', 'Records']
    },
    {
      county: 'Montgomery County',
      assessorName: 'Montgomery Central Appraisal District',
      website: 'https://www.mctx.org/departments/departments_a_-_m/appraisal_district',
      phone: '(936) 539-7800',
      address: '9659 Spring Cypress Rd, Spring, TX 77379',
      services: ['Property Valuation', 'Tax Records', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Galveston County',
      assessorName: 'Galveston Central Appraisal District',
      website: 'https://www.galvestoncad.org',
      phone: '(409) 766-2200',
      address: '9850 Emmett F Lowry Expy, Texas City, TX 77591',
      services: ['Property Assessment', 'Tax Information', 'Protest Process', 'Records']
    },
    {
      county: 'Brazoria County',
      assessorName: 'Brazoria Central Appraisal District',
      website: 'https://www.brazoriacad.org',
      phone: '(979) 864-1390',
      address: '500 N Chenango St, Angleton, TX 77515',
      services: ['Property Search', 'Appraisal Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Bell County',
      assessorName: 'Bell Central Appraisal District',
      website: 'https://www.bellcad.org',
      phone: '(254) 933-5412',
      address: '550 E 2nd Ave, Belton, TX 76513',
      services: ['Property Valuation', 'Tax Records', 'Protest Procedures', 'Records']
    },
    {
      county: 'Nueces County',
      assessorName: 'Nueces County Appraisal District',
      website: 'https://www.nuecescad.org',
      phone: '(361) 888-0391',
      address: '2624 Holly Rd, Corpus Christi, TX 78415',
      services: ['Property Assessment', 'Tax Information', 'Appeals', 'Exemptions']
    },
    {
      county: 'Jefferson County',
      assessorName: 'Jefferson County Appraisal District',
      website: 'https://www.jcad.org',
      phone: '(409) 835-8461',
      address: '1149 Pearl St, Beaumont, TX 77701',
      services: ['Property Search', 'Appraisal Information', 'Protests', 'Records']
    },
    {
      county: 'McLennan County',
      assessorName: 'McLennan Central Appraisal District',
      website: 'https://www.mclennancad.org',
      phone: '(254) 752-9049',
      address: '315 S 26th St, Waco, TX 76710',
      services: ['Property Valuation', 'Tax Records', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Hays County',
      assessorName: 'Hays Central Appraisal District',
      website: 'https://www.hayscad.com',
      phone: '(512) 393-2254',
      address: '712 S Stagecoach Trail, San Marcos, TX 78666',
      services: ['Property Assessment', 'Tax Information', 'Protest Process', 'Records']
    },
    {
      county: 'Guadalupe County',
      assessorName: 'Guadalupe Central Appraisal District',
      website: 'https://www.guadalupecad.org',
      phone: '(830) 379-4477',
      address: '125 Landa St, New Braunfels, TX 78130',
      services: ['Property Search', 'Appraisal Records', 'Appeals', 'Exemptions']
    }
  ],
  'FL': [
    {
      county: 'Miami-Dade County',
      assessorName: 'Miami-Dade County Property Appraiser',
      website: 'https://www.miamidade.gov/pa',
      phone: '(305) 375-4712',
      address: '140 W Flagler St, Miami, FL 33130',
      services: ['Property Search', 'Assessment Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Broward County',
      assessorName: 'Broward County Property Appraiser',
      website: 'https://www.bcpa.net',
      phone: '(954) 357-6830',
      address: '115 S Andrews Ave, Fort Lauderdale, FL 33301',
      services: ['Property Valuation', 'Tax Records', 'Homestead Exemptions', 'Appeals']
    },
    {
      county: 'Palm Beach County',
      assessorName: 'Palm Beach County Property Appraiser',
      website: 'https://www.pbcgov.org/papa',
      phone: '(561) 355-2866',
      address: '301 N Olive Ave, West Palm Beach, FL 33401',
      services: ['Property Assessment', 'Tax Information', 'Exemptions', 'Records Search']
    },
    {
      county: 'Hillsborough County',
      assessorName: 'Hillsborough County Property Appraiser',
      website: 'https://www.hcpafl.org',
      phone: '(813) 272-6100',
      address: '601 E Kennedy Blvd, Tampa, FL 33602',
      services: ['Property Records', 'Assessment Data', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Orange County',
      assessorName: 'Orange County Property Appraiser',
      website: 'https://www.ocpafl.org',
      phone: '(407) 836-5044',
      address: '201 S Rosalind Ave, Orlando, FL 32801',
      services: ['Property Search', 'Tax Assessment', 'Homestead Applications', 'Appeals']
    },
    {
      county: 'Pinellas County',
      assessorName: 'Pinellas County Property Appraiser',
      website: 'https://www.pcpao.org',
      phone: '(727) 464-3207',
      address: '315 Court St, Clearwater, FL 33756',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    },
    {
      county: 'Duval County',
      assessorName: 'Duval County Property Appraiser',
      website: 'https://paduval.coj.net',
      phone: '(904) 630-2011',
      address: '231 E Forsyth St, Jacksonville, FL 32202',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Lee County',
      assessorName: 'Lee County Property Appraiser',
      website: 'https://www.leepa.org',
      phone: '(239) 533-6100',
      address: '2480 Thompson St, Fort Myers, FL 33901',
      services: ['Property Search', 'Assessment Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Polk County',
      assessorName: 'Polk County Property Appraiser',
      website: 'https://www.polkpa.org',
      phone: '(863) 534-4777',
      address: '255 N Broadway Ave, Bartow, FL 33830',
      services: ['Property Valuation', 'Tax Records', 'Homestead Exemptions', 'Appeals']
    },
    {
      county: 'Brevard County',
      assessorName: 'Brevard County Property Appraiser',
      website: 'https://www.bcpao.us',
      phone: '(321) 637-5823',
      address: '400 S Street, Viera, FL 32940',
      services: ['Property Assessment', 'Tax Information', 'Exemptions', 'Records']
    }
  ],
  'NY': [
    {
      county: 'New York County (Manhattan)',
      assessorName: 'NYC Department of Finance',
      website: 'https://www1.nyc.gov/site/finance',
      phone: '(311) 692-9200',
      address: '1 Centre St, New York, NY 10007',
      services: ['Property Assessment', 'Tax Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Kings County (Brooklyn)',
      assessorName: 'NYC Department of Finance - Brooklyn',
      website: 'https://www1.nyc.gov/site/finance',
      phone: '(311) 692-9200',
      address: '210 Joralemon St, Brooklyn, NY 11201',
      services: ['Property Valuation', 'Tax Information', 'Assessment Records', 'Appeals']
    },
    {
      county: 'Queens County',
      assessorName: 'NYC Department of Finance - Queens',
      website: 'https://www1.nyc.gov/site/finance',
      phone: '(311) 692-9200',
      address: '144-06 94th Ave, Jamaica, NY 11435',
      services: ['Property Search', 'Tax Assessment', 'Exemptions', 'Records']
    },
    {
      county: 'Nassau County',
      assessorName: 'Nassau County Assessment Department',
      website: 'https://www.nassaucountyny.gov/agencies/Assessment',
      phone: '(516) 571-1500',
      address: '240 Old Country Rd, Mineola, NY 11501',
      services: ['Property Assessment', 'Tax Records', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Suffolk County',
      assessorName: 'Suffolk County Real Property Tax Service Agency',
      website: 'https://www.suffolkcountyny.gov/rptsa',
      phone: '(631) 852-7900',
      address: '345 Veterans Memorial Hwy, Hauppauge, NY 11788',
      services: ['Property Records', 'Assessment Information', 'Tax Data', 'Appeals']
    },
    {
      county: 'Bronx County',
      assessorName: 'NYC Department of Finance - Bronx',
      website: 'https://www1.nyc.gov/site/finance',
      phone: '(311) 692-9200',
      address: '1932 Arthur Ave, Bronx, NY 10457',
      services: ['Property Assessment', 'Tax Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Richmond County (Staten Island)',
      assessorName: 'NYC Department of Finance - Staten Island',
      website: 'https://www1.nyc.gov/site/finance',
      phone: '(311) 692-9200',
      address: '350 St Marks Pl, Staten Island, NY 10301',
      services: ['Property Valuation', 'Tax Information', 'Assessment Records', 'Appeals']
    },
    {
      county: 'Westchester County',
      assessorName: 'Westchester County Real Property Tax Service Agency',
      website: 'https://rpts.westchestergov.com',
      phone: '(914) 995-2750',
      address: '148 Martine Ave, White Plains, NY 10601',
      services: ['Property Search', 'Tax Assessment', 'Exemptions', 'Records']
    },
    {
      county: 'Erie County',
      assessorName: 'Erie County Real Property Tax Services',
      website: 'https://www.erie.gov/rpts',
      phone: '(716) 858-8500',
      address: '95 Franklin St, Buffalo, NY 14202',
      services: ['Property Assessment', 'Tax Information', 'Appeals Process', 'Exemptions']
    },
    {
      county: 'Monroe County',
      assessorName: 'Monroe County Real Property Tax Service Agency',
      website: 'https://www.monroecounty.gov/etc-rpts',
      phone: '(585) 753-1109',
      address: '130 S Plymouth Ave, Rochester, NY 14614',
      services: ['Property Records', 'Assessment Data', 'Tax Information', 'Appeals']
    }
  ],
  'PA': [
    {
      county: 'Philadelphia County',
      assessorName: 'Philadelphia Office of Property Assessment',
      website: 'https://www.phila.gov/departments/office-of-property-assessment',
      phone: '(215) 686-9200',
      address: '1401 John F Kennedy Blvd, Philadelphia, PA 19102',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Allegheny County',
      assessorName: 'Allegheny County Real Estate Division',
      website: 'https://www.alleghenycounty.us/real-estate',
      phone: '(412) 350-4636',
      address: '542 Forbes Ave, Pittsburgh, PA 15219',
      services: ['Property Search', 'Assessment Records', 'Appeals Process', 'Tax Information']
    },
    {
      county: 'Montgomery County',
      assessorName: 'Montgomery County Assessment Office',
      website: 'https://www.montcopa.org/1829/Assessment-Office',
      phone: '(610) 278-3000',
      address: '1 Montgomery Plaza, Norristown, PA 19401',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals']
    },
    {
      county: 'Bucks County',
      assessorName: 'Bucks County Assessment Office',
      website: 'https://www.buckscounty.org/government/CoreDepartments/Assessment',
      phone: '(215) 348-6000',
      address: '55 E Court St, Doylestown, PA 18901',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Chester County',
      assessorName: 'Chester County Assessment Office',
      website: 'https://www.chesco.org/1829/Assessment-Office',
      phone: '(610) 344-6100',
      address: '313 W Market St, West Chester, PA 19380',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals Process']
    }
  ],
  'IL': [
    {
      county: 'Cook County',
      assessorName: 'Cook County Assessor',
      website: 'https://www.cookcountyassessor.com',
      phone: '(312) 443-7550',
      address: '118 N Clark St, Chicago, IL 60602',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'DuPage County',
      assessorName: 'DuPage County Supervisor of Assessments',
      website: 'https://www.dupageco.org/soa',
      phone: '(630) 407-5500',
      address: '421 N County Farm Rd, Wheaton, IL 60187',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'Lake County',
      assessorName: 'Lake County Assessor',
      website: 'https://www.lakecountyil.gov/1821/Assessor',
      phone: '(847) 377-2300',
      address: '18 N County St, Waukegan, IL 60085',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    },
    {
      county: 'Will County',
      assessorName: 'Will County Supervisor of Assessments',
      website: 'https://www.willcountyillinois.com/offices/assessor',
      phone: '(815) 740-4600',
      address: '302 N Chicago St, Joliet, IL 60432',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Kane County',
      assessorName: 'Kane County Supervisor of Assessments',
      website: 'https://www.kanecountyil.gov/Pages/assessor.aspx',
      phone: '(630) 232-5912',
      address: '719 S Batavia Ave, Geneva, IL 60134',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'OH': [
    {
      county: 'Cuyahoga County',
      assessorName: 'Cuyahoga County Fiscal Officer',
      website: 'https://fiscalofficer.cuyahogacounty.us',
      phone: '(216) 443-7010',
      address: '2079 E 9th St, Cleveland, OH 44115',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Franklin County',
      assessorName: 'Franklin County Auditor',
      website: 'https://www.franklincountyauditor.com',
      phone: '(614) 525-3000',
      address: '373 S High St, Columbus, OH 43215',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'Hamilton County',
      assessorName: 'Hamilton County Auditor',
      website: 'https://www.hamiltoncountyauditor.org',
      phone: '(513) 946-4000',
      address: '138 E Court St, Cincinnati, OH 45202',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    },
    {
      county: 'Montgomery County',
      assessorName: 'Montgomery County Auditor',
      website: 'https://www.mcauditor.org',
      phone: '(937) 225-4000',
      address: '451 W 3rd St, Dayton, OH 45422',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Summit County',
      assessorName: 'Summit County Fiscal Office',
      website: 'https://www.co.summit.oh.us/fiscaloffice',
      phone: '(330) 643-2590',
      address: '175 S Main St, Akron, OH 44308',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'GA': [
    {
      county: 'Fulton County',
      assessorName: 'Fulton County Board of Assessors',
      website: 'https://www.fultoncountyga.gov/services/taxes-and-finance/board-of-assessors',
      phone: '(404) 612-6440',
      address: '141 Pryor St SW, Atlanta, GA 30303',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Gwinnett County',
      assessorName: 'Gwinnett County Board of Assessors',
      website: 'https://www.gwinnettcounty.com/web/gwinnett/departments/taxassessor',
      phone: '(770) 822-8800',
      address: '75 Langley Dr, Lawrenceville, GA 30046',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'DeKalb County',
      assessorName: 'DeKalb County Board of Assessors',
      website: 'https://www.dekalbcountyga.gov/board-assessors',
      phone: '(404) 298-4000',
      address: '1300 Commerce Dr, Decatur, GA 30030',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    },
    {
      county: 'Cobb County',
      assessorName: 'Cobb County Board of Assessors',
      website: 'https://www.cobbcounty.org/central-services/tax-assessors',
      phone: '(770) 528-8300',
      address: '100 Cherokee St, Marietta, GA 30090',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Clayton County',
      assessorName: 'Clayton County Board of Assessors',
      website: 'https://www.claytoncountyga.gov/government/departments-f-z/tax-assessor',
      phone: '(770) 477-3403',
      address: '112 Smith St, Jonesboro, GA 30236',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'AL': [
    {
      county: 'Jefferson County',
      assessorName: 'Jefferson County Revenue Commissioner',
      website: 'https://www.jccal.org/Default.asp?ID=1&pg=Revenue+Commissioner',
      phone: '(205) 325-5311',
      address: '716 Richard Arrington Jr Blvd N, Birmingham, AL 35203',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Mobile County',
      assessorName: 'Mobile County Revenue Commissioner',
      website: 'https://www.mobilecounty.org/revenue',
      phone: '(251) 574-8400',
      address: '205 Government St, Mobile, AL 36602',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'Madison County',
      assessorName: 'Madison County Revenue Commissioner',
      website: 'https://www.madisoncountyal.gov/departments/revenue-commissioner',
      phone: '(256) 532-3390',
      address: '100 Northside Sq, Huntsville, AL 35801',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    }
  ],
  'AK': [
    {
      county: 'Anchorage Municipality',
      assessorName: 'Municipality of Anchorage Assessor',
      website: 'https://www.muni.org/departments/ocpd/planning/pages/assessor.aspx',
      phone: '(907) 343-6131',
      address: '4700 Elmore Rd, Anchorage, AK 99507',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Fairbanks North Star Borough',
      assessorName: 'Fairbanks North Star Borough Assessor',
      website: 'https://www.fnsb.us/departments/assessing',
      phone: '(907) 459-1000',
      address: '809 Pioneer Rd, Fairbanks, AK 99701',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'AZ': [
    {
      county: 'Maricopa County',
      assessorName: 'Maricopa County Assessor',
      website: 'https://www.maricopa.gov/1326/Assessor',
      phone: '(602) 506-3406',
      address: '301 W Jefferson St, Phoenix, AZ 85003',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Pima County',
      assessorName: 'Pima County Assessor',
      website: 'https://www.asr.pima.gov',
      phone: '(520) 724-8630',
      address: '240 N Stone Ave, Tucson, AZ 85701',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'Pinal County',
      assessorName: 'Pinal County Assessor',
      website: 'https://www.pinalcountyaz.gov/assessor',
      phone: '(520) 866-6361',
      address: '31 N Pinal St, Florence, AZ 85132',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    }
  ],
  'AR': [
    {
      county: 'Pulaski County',
      assessorName: 'Pulaski County Assessor',
      website: 'https://www.pulaskicounty.net/assessor',
      phone: '(501) 340-8330',
      address: '501 W Markham St, Little Rock, AR 72201',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Washington County',
      assessorName: 'Washington County Assessor',
      website: 'https://www.washingtoncountyar.gov/departments/assessor',
      phone: '(479) 444-1711',
      address: '280 N College Ave, Fayetteville, AR 72701',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'CO': [
    {
      county: 'Denver County',
      assessorName: 'Denver Assessor',
      website: 'https://www.denvergov.org/Government/Agencies-Departments-Offices/Agencies-Departments-Offices-Directory/Assessor',
      phone: '(720) 913-4141',
      address: '201 W Colfax Ave, Denver, CO 80202',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Jefferson County',
      assessorName: 'Jefferson County Assessor',
      website: 'https://www.jeffco.us/1338/Assessor',
      phone: '(303) 271-8600',
      address: '100 Jefferson County Pkwy, Golden, CO 80419',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    },
    {
      county: 'Arapahoe County',
      assessorName: 'Arapahoe County Assessor',
      website: 'https://www.arapahoegov.com/1142/Assessor',
      phone: '(303) 795-4600',
      address: '5334 S Prince St, Littleton, CO 80120',
      services: ['Property Valuation', 'Tax Records', 'Exemptions', 'Appeals Process']
    }
  ],
  'CT': [
    {
      county: 'Fairfield County',
      assessorName: 'Fairfield County Assessor',
      website: 'https://www.fairfieldct.org/assessor',
      phone: '(203) 256-3120',
      address: '611 Old Post Rd, Fairfield, CT 06824',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Hartford County',
      assessorName: 'Hartford County Assessor',
      website: 'https://www.hartford.gov/assessor',
      phone: '(860) 757-9275',
      address: '550 Main St, Hartford, CT 06103',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'DE': [
    {
      county: 'New Castle County',
      assessorName: 'New Castle County Assessment Division',
      website: 'https://www.nccde.org/1356/Assessment-Division',
      phone: '(302) 395-5555',
      address: '87 Read Way, New Castle, DE 19720',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Kent County',
      assessorName: 'Kent County Assessment Office',
      website: 'https://www.co.kent.de.us/departments/assessment',
      phone: '(302) 744-2400',
      address: '555 Bay Rd, Dover, DE 19901',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'HI': [
    {
      county: 'Honolulu County',
      assessorName: 'City and County of Honolulu Real Property Assessment',
      website: 'https://www.honolulu.gov/rpa',
      phone: '(808) 768-3799',
      address: '842 Bethel St, Honolulu, HI 96813',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Hawaii County',
      assessorName: 'Hawaii County Real Property Tax Division',
      website: 'https://www.hawaiicounty.gov/departments/finance/real-property-tax',
      phone: '(808) 961-8201',
      address: '25 Aupuni St, Hilo, HI 96720',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'ID': [
    {
      county: 'Ada County',
      assessorName: 'Ada County Assessor',
      website: 'https://adacounty.id.gov/assessor',
      phone: '(208) 287-6200',
      address: '190 E Front St, Boise, ID 83702',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Canyon County',
      assessorName: 'Canyon County Assessor',
      website: 'https://www.canyonco.org/assessor',
      phone: '(208) 454-7300',
      address: '1115 Albany St, Caldwell, ID 83605',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'IN': [
    {
      county: 'Marion County',
      assessorName: 'Marion County Assessor',
      website: 'https://www.indy.gov/agency/assessor',
      phone: '(317) 327-4000',
      address: '200 E Washington St, Indianapolis, IN 46204',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Lake County',
      assessorName: 'Lake County Assessor',
      website: 'https://www.lakecountyin.org/assessor',
      phone: '(219) 755-3070',
      address: '2293 N Main St, Crown Point, IN 46307',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'IA': [
    {
      county: 'Polk County',
      assessorName: 'Polk County Assessor',
      website: 'https://www.polkcountyiowa.gov/assessor',
      phone: '(515) 286-3001',
      address: '111 Court Ave, Des Moines, IA 50309',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Linn County',
      assessorName: 'Linn County Assessor',
      website: 'https://www.linncounty.org/assessor',
      phone: '(319) 892-5000',
      address: '935 2nd St SW, Cedar Rapids, IA 52404',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'KS': [
    {
      county: 'Johnson County',
      assessorName: 'Johnson County Appraiser',
      website: 'https://www.jocogov.org/dept/appraiser',
      phone: '(913) 715-9000',
      address: '111 S Cherry St, Olathe, KS 66061',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Sedgwick County',
      assessorName: 'Sedgwick County Appraiser',
      website: 'https://www.sedgwickcounty.org/appraiser',
      phone: '(316) 660-9000',
      address: '525 N Main St, Wichita, KS 67203',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'KY': [
    {
      county: 'Jefferson County',
      assessorName: 'Jefferson County Property Valuation Administrator',
      website: 'https://jeffersonpva.ky.gov',
      phone: '(502) 574-6380',
      address: '531 Court Pl, Louisville, KY 40202',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Fayette County',
      assessorName: 'Fayette County Property Valuation Administrator',
      website: 'https://www.fayettepva.com',
      phone: '(859) 253-3344',
      address: '162 E Main St, Lexington, KY 40507',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'LA': [
    {
      county: 'Orleans Parish',
      assessorName: 'Orleans Parish Assessor',
      website: 'https://www.orleansassessor.com',
      phone: '(504) 658-1300',
      address: '1300 Perdido St, New Orleans, LA 70112',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Jefferson Parish',
      assessorName: 'Jefferson Parish Assessor',
      website: 'https://www.jpassessor.com',
      phone: '(504) 736-6800',
      address: '1221 Elmwood Park Blvd, Harahan, LA 70123',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'ME': [
    {
      county: 'Cumberland County',
      assessorName: 'Cumberland County Assessor',
      website: 'https://www.cumberlandcounty.org/assessor',
      phone: '(207) 871-8380',
      address: '142 Federal St, Portland, ME 04101',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'MD': [
    {
      county: 'Montgomery County',
      assessorName: 'Montgomery County Assessment and Taxation',
      website: 'https://www.montgomerycountymd.gov/finance/assessment',
      phone: '(240) 777-8900',
      address: '255 Rockville Pike, Rockville, MD 20850',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Prince Georges County',
      assessorName: 'Prince Georges County Assessment Administration',
      website: 'https://www.princegeorgescountymd.gov/1117/Assessment-Administration',
      phone: '(301) 952-3220',
      address: '1400 McCormick Dr, Largo, MD 20774',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'MA': [
    {
      county: 'Middlesex County',
      assessorName: 'Middlesex County Assessor',
      website: 'https://www.middlesexcounty.com/assessor',
      phone: '(617) 494-4300',
      address: '40 Thorndike St, Cambridge, MA 02141',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Worcester County',
      assessorName: 'Worcester County Assessor',
      website: 'https://www.worcestercounty.com/assessor',
      phone: '(508) 799-1550',
      address: '2 Main St, Worcester, MA 01608',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'MI': [
    {
      county: 'Wayne County',
      assessorName: 'Wayne County Treasurer',
      website: 'https://www.waynecounty.com/departments/treasurer',
      phone: '(313) 224-5990',
      address: '400 Monroe St, Detroit, MI 48226',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Oakland County',
      assessorName: 'Oakland County Equalization Department',
      website: 'https://www.oakgov.com/equalization',
      phone: '(248) 858-0740',
      address: '1200 N Telegraph Rd, Pontiac, MI 48341',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'MN': [
    {
      county: 'Hennepin County',
      assessorName: 'Hennepin County Assessor',
      website: 'https://www.hennepin.us/residents/property/assessor',
      phone: '(612) 348-3011',
      address: '300 S 6th St, Minneapolis, MN 55487',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Ramsey County',
      assessorName: 'Ramsey County Assessor',
      website: 'https://www.ramseycounty.us/residents/property-parcels/property-records-values',
      phone: '(651) 266-2000',
      address: '121 7th Pl E, Saint Paul, MN 55101',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'MS': [
    {
      county: 'Hinds County',
      assessorName: 'Hinds County Tax Assessor',
      website: 'https://www.co.hinds.ms.us/pgs/apps/depts/default.asp?id=18',
      phone: '(601) 968-6507',
      address: '316 S President St, Jackson, MS 39201',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ],
  'MO': [
    {
      county: 'St. Louis County',
      assessorName: 'St. Louis County Assessor',
      website: 'https://www.stlouiscountymo.gov/st-louis-county-departments/revenue/assessor',
      phone: '(314) 615-7166',
      address: '41 S Central Ave, Clayton, MO 63105',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Jackson County',
      assessorName: 'Jackson County Assessment Department',
      website: 'https://www.jacksongov.org/1142/Assessment',
      phone: '(816) 881-3232',
      address: '415 E 12th St, Kansas City, MO 64106',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'MT': [
    {
      county: 'Yellowstone County',
      assessorName: 'Yellowstone County Assessor',
      website: 'https://www.co.yellowstone.mt.gov/government/departments/assessor',
      phone: '(406) 256-2785',
      address: '217 N 27th St, Billings, MT 59101',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ],
  'NE': [
    {
      county: 'Douglas County',
      assessorName: 'Douglas County Assessor',
      website: 'https://www.douglascounty-ne.gov/assessor',
      phone: '(402) 444-7000',
      address: '1819 Farnam St, Omaha, NE 68183',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'NV': [
    {
      county: 'Clark County',
      assessorName: 'Clark County Assessor',
      website: 'https://www.clarkcountynv.gov/government/departments/assessor',
      phone: '(702) 455-3882',
      address: '500 S Grand Central Pkwy, Las Vegas, NV 89155',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Washoe County',
      assessorName: 'Washoe County Assessor',
      website: 'https://www.washoecounty.us/assessor',
      phone: '(775) 328-2231',
      address: '1001 E 9th St, Reno, NV 89512',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'NH': [
    {
      county: 'Hillsborough County',
      assessorName: 'Hillsborough County Assessor',
      website: 'https://www.hillsboroughcountynh.org/assessor',
      phone: '(603) 627-5605',
      address: '329 Mast Rd, Goffstown, NH 03045',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'NJ': [
    {
      county: 'Bergen County',
      assessorName: 'Bergen County Tax Board',
      website: 'https://www.co.bergen.nj.us/tax-board',
      phone: '(201) 336-6000',
      address: '1 Bergen County Plaza, Hackensack, NJ 07601',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Essex County',
      assessorName: 'Essex County Tax Board',
      website: 'https://www.essexcountynj.org/tax-board',
      phone: '(973) 621-4921',
      address: '465 Dr Martin Luther King Jr Blvd, Newark, NJ 07102',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'NM': [
    {
      county: 'Bernalillo County',
      assessorName: 'Bernalillo County Assessor',
      website: 'https://www.bernco.gov/assessor',
      phone: '(505) 468-7000',
      address: '1 Civic Plaza NW, Albuquerque, NM 87102',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'NC': [
    {
      county: 'Mecklenburg County',
      assessorName: 'Mecklenburg County Assessor',
      website: 'https://www.mecknc.gov/assessorsoffice',
      phone: '(980) 314-2700',
      address: '600 E 4th St, Charlotte, NC 28202',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Wake County',
      assessorName: 'Wake County Tax Administration',
      website: 'https://www.wakegov.com/departments-government/tax-administration',
      phone: '(919) 856-5400',
      address: '300 Fayetteville St, Raleigh, NC 27601',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'ND': [
    {
      county: 'Cass County',
      assessorName: 'Cass County Director of Tax Equalization',
      website: 'https://www.casscountynd.gov/our-county/departments/director-of-tax-equalization',
      phone: '(701) 241-5800',
      address: '211 9th St S, Fargo, ND 58103',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'OK': [
    {
      county: 'Oklahoma County',
      assessorName: 'Oklahoma County Assessor',
      website: 'https://www.oklahomacounty.org/assessor',
      phone: '(405) 713-1122',
      address: '320 Robert S Kerr Ave, Oklahoma City, OK 73102',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Tulsa County',
      assessorName: 'Tulsa County Assessor',
      website: 'https://www.tulsacounty.org/assessor',
      phone: '(918) 596-5000',
      address: '500 S Denver Ave, Tulsa, OK 74103',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'OR': [
    {
      county: 'Multnomah County',
      assessorName: 'Multnomah County Assessment and Taxation',
      website: 'https://www.multco.us/assessment-taxation',
      phone: '(503) 988-3326',
      address: '501 SE Hawthorne Blvd, Portland, OR 97214',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Washington County',
      assessorName: 'Washington County Assessment and Taxation',
      website: 'https://www.co.washington.or.us/AssessmentTaxation',
      phone: '(503) 846-8741',
      address: '155 N 1st Ave, Hillsboro, OR 97124',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'RI': [
    {
      county: 'Providence County',
      assessorName: 'Providence County Assessor',
      website: 'https://www.providenceri.gov/assessor',
      phone: '(401) 421-7740',
      address: '25 Dorrance St, Providence, RI 02903',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ],
  'SC': [
    {
      county: 'Charleston County',
      assessorName: 'Charleston County Assessor',
      website: 'https://www.charlestoncounty.org/departments/assessor',
      phone: '(843) 958-4200',
      address: '4045 Bridge View Dr, North Charleston, SC 29405',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Greenville County',
      assessorName: 'Greenville County Assessor',
      website: 'https://www.greenvillecounty.org/assessor',
      phone: '(864) 467-7000',
      address: '301 University Ridge, Greenville, SC 29601',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'SD': [
    {
      county: 'Minnehaha County',
      assessorName: 'Minnehaha County Director of Equalization',
      website: 'https://www.minnehahacounty.org/departments/equalization',
      phone: '(605) 367-4337',
      address: '415 N Dakota Ave, Sioux Falls, SD 57104',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ],
  'TN': [
    {
      county: 'Davidson County',
      assessorName: 'Davidson County Assessor of Property',
      website: 'https://www.padctn.org',
      phone: '(615) 862-6000',
      address: '222 2nd Ave N, Nashville, TN 37201',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Shelby County',
      assessorName: 'Shelby County Assessor',
      website: 'https://www.shelbyassessor.com',
      phone: '(901) 222-2000',
      address: '160 N Main St, Memphis, TN 38103',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'UT': [
    {
      county: 'Salt Lake County',
      assessorName: 'Salt Lake County Assessor',
      website: 'https://slco.org/assessor',
      phone: '(385) 468-8000',
      address: '2001 S State St, Salt Lake City, UT 84190',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Utah County',
      assessorName: 'Utah County Assessor',
      website: 'https://www.utahcounty.gov/dept/assessor',
      phone: '(801) 851-8026',
      address: '100 E Center St, Provo, UT 84606',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'VT': [
    {
      county: 'Chittenden County',
      assessorName: 'Chittenden County Assessor',
      website: 'https://www.chittendencounty.org/assessor',
      phone: '(802) 863-7200',
      address: '175 Main St, Burlington, VT 05401',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    }
  ],
  'VA': [
    {
      county: 'Fairfax County',
      assessorName: 'Fairfax County Department of Tax Administration',
      website: 'https://www.fairfaxcounty.gov/taxes',
      phone: '(703) 222-8234',
      address: '12000 Government Center Pkwy, Fairfax, VA 22035',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    },
    {
      county: 'Virginia Beach',
      assessorName: 'Virginia Beach Assessor',
      website: 'https://www.vbgov.com/government/departments/real-estate-assessor',
      phone: '(757) 385-4636',
      address: '2405 Courthouse Dr, Virginia Beach, VA 23456',
      services: ['Property Search', 'Assessment Data', 'Tax Records', 'Appeals']
    }
  ],
  'WA': [
    {
      county: 'King County',
      assessorName: 'King County Assessor',
      website: 'https://www.kingcounty.gov/depts/assessor',
      phone: '(206) 296-7300',
      address: '500 4th Ave, Seattle, WA 98104',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Pierce County',
      assessorName: 'Pierce County Assessor-Treasurer',
      website: 'https://www.piercecountywa.gov/1825/Assessor-Treasurer',
      phone: '(253) 798-7480',
      address: '2401 S 35th St, Tacoma, WA 98409',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'WV': [
    {
      county: 'Kanawha County',
      assessorName: 'Kanawha County Assessor',
      website: 'https://www.kanawha.us/assessor',
      phone: '(304) 357-0230',
      address: '409 Virginia St E, Charleston, WV 25301',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ],
  'WI': [
    {
      county: 'Milwaukee County',
      assessorName: 'Milwaukee County Assessment Services',
      website: 'https://county.milwaukee.gov/EN/Administrative-Services/Assessment-Services',
      phone: '(414) 278-4032',
      address: '901 N 9th St, Milwaukee, WI 53233',
      services: ['Property Assessment', 'Tax Records', 'Appeals', 'Exemptions']
    },
    {
      county: 'Dane County',
      assessorName: 'Dane County Assessment Office',
      website: 'https://www.danecounty.com/departments/assessment',
      phone: '(608) 266-4141',
      address: '210 Martin Luther King Jr Blvd, Madison, WI 53703',
      services: ['Property Search', 'Assessment Records', 'Tax Information', 'Appeals']
    }
  ],
  'WY': [
    {
      county: 'Laramie County',
      assessorName: 'Laramie County Assessor',
      website: 'https://www.laramiecounty.com/assessor',
      phone: '(307) 633-4242',
      address: '309 W 20th St, Cheyenne, WY 82001',
      services: ['Property Assessment', 'Tax Information', 'Records Search', 'Appeals']
    }
  ]
};
